/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * To change the format of this file, modify `createIconDocs` in icon-build-process/src/create-icon-docs.tsx.
 *
 * @codegen <<SignedSource::e19dd7c8ce4cafa5a731b96f9815dc96>>
 * @codegenCommand yarn build:icon-glyphs
 */
/* eslint-disable import/no-extraneous-dependencies -- This import is within the same package, hence self-referential. */

interface Data {
	keywords: string[];
	componentName: string;
	package: string;
	packageLoader: () => Promise<{ default: React.ComponentType<any> }>;
}

export const metaDataWithPackageLoader: Record<string, Data> = {
	'blog/16': {
		keywords: ['blog/16', 'blog16', 'object', 'icon-object'],
		componentName: 'Blog16Icon',
		package: './artifacts/glyph/blog/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/blog/16'
			),
	},
	'branch/16': {
		keywords: ['branch/16', 'branch16', 'object', 'icon-object'],
		componentName: 'Branch16Icon',
		package: './artifacts/glyph/branch/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/branch/16'
			),
	},
	'bug/16': {
		keywords: ['bug/16', 'bug16', 'object', 'icon-object'],
		componentName: 'Bug16Icon',
		package: './artifacts/glyph/bug/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/bug/16'
			),
	},
	'calendar/16': {
		keywords: ['calendar/16', 'calendar16', 'object', 'icon-object'],
		componentName: 'Calendar16Icon',
		package: './artifacts/glyph/calendar/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/calendar/16'
			),
	},
	'changes/16': {
		keywords: ['changes/16', 'changes16', 'object', 'icon-object'],
		componentName: 'Changes16Icon',
		package: './artifacts/glyph/changes/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/changes/16'
			),
	},
	'code/16': {
		keywords: ['code/16', 'code16', 'object', 'icon-object'],
		componentName: 'Code16Icon',
		package: './artifacts/glyph/code/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/code/16'
			),
	},
	'commit/16': {
		keywords: ['commit/16', 'commit16', 'object', 'icon-object'],
		componentName: 'Commit16Icon',
		package: './artifacts/glyph/commit/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/commit/16'
			),
	},
	'epic/16': {
		keywords: ['epic/16', 'epic16', 'object', 'icon-object'],
		componentName: 'Epic16Icon',
		package: './artifacts/glyph/epic/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/epic/16'
			),
	},
	'improvement/16': {
		keywords: ['improvement/16', 'improvement16', 'object', 'icon-object'],
		componentName: 'Improvement16Icon',
		package: './artifacts/glyph/improvement/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/improvement/16'
			),
	},
	'incident/16': {
		keywords: ['incident/16', 'incident16', 'object', 'icon-object'],
		componentName: 'Incident16Icon',
		package: './artifacts/glyph/incident/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/incident/16'
			),
	},
	'issue/16': {
		keywords: ['issue/16', 'issue16', 'object', 'icon-object'],
		componentName: 'Issue16Icon',
		package: './artifacts/glyph/issue/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/issue/16'
			),
	},
	'new-feature/16': {
		keywords: ['new-feature/16', 'newfeature16', 'object', 'icon-object'],
		componentName: 'NewFeature16Icon',
		package: './artifacts/glyph/new-feature/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/new-feature/16'
			),
	},
	'page-live-doc/16': {
		keywords: ['page-live-doc/16', 'pagelivedoc16', 'object', 'icon-object'],
		componentName: 'PageLiveDoc16Icon',
		package: './artifacts/glyph/page-live-doc/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/page-live-doc/16'
			),
	},
	'page/16': {
		keywords: ['page/16', 'page16', 'object', 'icon-object'],
		componentName: 'Page16Icon',
		package: './artifacts/glyph/page/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/page/16'
			),
	},
	'problem/16': {
		keywords: ['problem/16', 'problem16', 'object', 'icon-object'],
		componentName: 'Problem16Icon',
		package: './artifacts/glyph/problem/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/problem/16'
			),
	},
	'pull-request/16': {
		keywords: ['pull-request/16', 'pullrequest16', 'object', 'icon-object'],
		componentName: 'PullRequest16Icon',
		package: './artifacts/glyph/pull-request/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/pull-request/16'
			),
	},
	'question/16': {
		keywords: ['question/16', 'question16', 'object', 'icon-object'],
		componentName: 'Question16Icon',
		package: './artifacts/glyph/question/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/question/16'
			),
	},
	'story/16': {
		keywords: ['story/16', 'story16', 'object', 'icon-object'],
		componentName: 'Story16Icon',
		package: './artifacts/glyph/story/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/story/16'
			),
	},
	'subtask/16': {
		keywords: ['subtask/16', 'subtask16', 'object', 'icon-object'],
		componentName: 'Subtask16Icon',
		package: './artifacts/glyph/subtask/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/subtask/16'
			),
	},
	'task/16': {
		keywords: ['task/16', 'task16', 'object', 'icon-object'],
		componentName: 'Task16Icon',
		package: './artifacts/glyph/task/16',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/task/16'
			),
	},
	'blog/24': {
		keywords: ['blog/24', 'blog24', 'object', 'icon-object'],
		componentName: 'Blog24Icon',
		package: './artifacts/glyph/blog/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/blog/24'
			),
	},
	'branch/24': {
		keywords: ['branch/24', 'branch24', 'object', 'icon-object'],
		componentName: 'Branch24Icon',
		package: './artifacts/glyph/branch/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/branch/24'
			),
	},
	'bug/24': {
		keywords: ['bug/24', 'bug24', 'object', 'icon-object'],
		componentName: 'Bug24Icon',
		package: './artifacts/glyph/bug/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/bug/24'
			),
	},
	'calendar/24': {
		keywords: ['calendar/24', 'calendar24', 'object', 'icon-object'],
		componentName: 'Calendar24Icon',
		package: './artifacts/glyph/calendar/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/calendar/24'
			),
	},
	'changes/24': {
		keywords: ['changes/24', 'changes24', 'object', 'icon-object'],
		componentName: 'Changes24Icon',
		package: './artifacts/glyph/changes/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/changes/24'
			),
	},
	'code/24': {
		keywords: ['code/24', 'code24', 'object', 'icon-object'],
		componentName: 'Code24Icon',
		package: './artifacts/glyph/code/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/code/24'
			),
	},
	'commit/24': {
		keywords: ['commit/24', 'commit24', 'object', 'icon-object'],
		componentName: 'Commit24Icon',
		package: './artifacts/glyph/commit/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/commit/24'
			),
	},
	'epic/24': {
		keywords: ['epic/24', 'epic24', 'object', 'icon-object'],
		componentName: 'Epic24Icon',
		package: './artifacts/glyph/epic/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/epic/24'
			),
	},
	'improvement/24': {
		keywords: ['improvement/24', 'improvement24', 'object', 'icon-object'],
		componentName: 'Improvement24Icon',
		package: './artifacts/glyph/improvement/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/improvement/24'
			),
	},
	'incident/24': {
		keywords: ['incident/24', 'incident24', 'object', 'icon-object'],
		componentName: 'Incident24Icon',
		package: './artifacts/glyph/incident/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/incident/24'
			),
	},
	'issue/24': {
		keywords: ['issue/24', 'issue24', 'object', 'icon-object'],
		componentName: 'Issue24Icon',
		package: './artifacts/glyph/issue/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/issue/24'
			),
	},
	'new-feature/24': {
		keywords: ['new-feature/24', 'newfeature24', 'object', 'icon-object'],
		componentName: 'NewFeature24Icon',
		package: './artifacts/glyph/new-feature/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/new-feature/24'
			),
	},
	'page-live-doc/24': {
		keywords: ['page-live-doc/24', 'pagelivedoc24', 'object', 'icon-object'],
		componentName: 'PageLiveDoc24Icon',
		package: './artifacts/glyph/page-live-doc/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/page-live-doc/24'
			),
	},
	'page/24': {
		keywords: ['page/24', 'page24', 'object', 'icon-object'],
		componentName: 'Page24Icon',
		package: './artifacts/glyph/page/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/page/24'
			),
	},
	'problem/24': {
		keywords: ['problem/24', 'problem24', 'object', 'icon-object'],
		componentName: 'Problem24Icon',
		package: './artifacts/glyph/problem/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/problem/24'
			),
	},
	'pull-request/24': {
		keywords: ['pull-request/24', 'pullrequest24', 'object', 'icon-object'],
		componentName: 'PullRequest24Icon',
		package: './artifacts/glyph/pull-request/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/pull-request/24'
			),
	},
	'question/24': {
		keywords: ['question/24', 'question24', 'object', 'icon-object'],
		componentName: 'Question24Icon',
		package: './artifacts/glyph/question/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/question/24'
			),
	},
	'story/24': {
		keywords: ['story/24', 'story24', 'object', 'icon-object'],
		componentName: 'Story24Icon',
		package: './artifacts/glyph/story/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/story/24'
			),
	},
	'subtask/24': {
		keywords: ['subtask/24', 'subtask24', 'object', 'icon-object'],
		componentName: 'Subtask24Icon',
		package: './artifacts/glyph/subtask/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/subtask/24'
			),
	},
	'task/24': {
		keywords: ['task/24', 'task24', 'object', 'icon-object'],
		componentName: 'Task24Icon',
		package: './artifacts/glyph/task/24',
		packageLoader: () =>
			import(
				/* webpackChunkName: "@atlaskit-internal_icon" */
				'./artifacts/glyph/task/24'
			),
	},
};

const metaData: Record<string, Omit<Data, 'packageLoader'>> = Object.fromEntries(
	Object.entries(metaDataWithPackageLoader).map(([key, { packageLoader, ...rest }]) => [key, rest]),
);

export default metaData;
